import { shape, number, string, oneOf,  arrayOf, objectOf } from 'prop-types';

export const umoksType = shape({
  id: number,
  compamy: string.isRequired,
  firstName: string.isRequired,
  lastName: string.isRequired,

  menuList: arrayOf(
    shape({
      id:  number.isRequired,
      item: string.isRequired
    }).isRequired
  ).isRequired,

  tenetList:objectOf(
    shape({
      title:  number.isRequired,
      img: string.isRequired,
      cardcontent: string.isRequired,
      content:arrayOf(
        shape({
          img:string.isRequired,
          imgtitle:string.isRequired,
          content:string.isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired,

  videoList:objectOf(
    shape({
      playVideo:string.isRequired,
      videoList:arrayOf(
        shape({
          video:string.isRequired,
          img:string.isRequired,
          title:string.isRequired,
          content:string.isRequired
        }).isRequired
      )

    }).isRequired
  ).isRequired,

  sodToDayList:objectOf(
    shape({
      title:string.isRequired,

      items:arrayOf(
        shape({
          icon:string.isRequired,
          content:string.isRequired
        }).isRequired
      )

    }).isRequired
  ).isRequired,

  industryList:arrayOf(
    shape({
      img:string.isRequired,
      content:string.isRequired
    }).isRequired
  ).isRequired,

  indproductList:arrayOf(
    shape({
      img:string.isRequired,
      content:string.isRequired
    }).isRequired
  ).isRequired,

  productList:objectOf(
    shape({
      title:string.isRequired,
      content:arrayOf(
        shape({
          img:string.isRequired,
          imgtitle:string.isRequired,
          content:string.isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired,

  teamList:objectOf(
    shape({
      title:string.isRequired,

      content:arrayOf(
        shape({
          img:string.isRequired,
          content:string.isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired,

  advertList:arrayOf(
    shape({
      ref:string.isRequired,
      img:string.isRequired
    }).isRequired
  ).isRequired,

  buisnessList:objectOf(
    shape({
      title:string.isRequired,
      content:arrayOf(
        shape({
          item:string.isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired,

  licList:objectOf(
    shape({
      title:string.isRequired,
      content:arrayOf(
        shape({
          img:string.isRequired,
          title:string.isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired,

  titlePrice: objectOf(
    shape({
      front:  objectOf(
        shape({
          title:string.isRequired,
          content:string.isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired,
  presentationList:objectOf(
    shape({
      title:string.isRequired,
      content:arrayOf(
        shape({
          ref:string.isRequired,
          img:string.isRequired,
          title:string.isRequired

        }).isRequired
      )
    }).isRequired
  ).isRequired,

  contactList:objectOf(
    shape({
      title:string.isRequired,
      content:arrayOf(
        shape({
          title:string.isRequired,
          content:arrayOf(
            shape({
              title:string.isRequired,
              adress:string.isRequired,
              tel:string.isRequired,
              fax:string.isRequired,
              mail:string.isRequired
            }).isRequired
          )
        }).isRequired
      )
    }).isRequired
  ).isRequired,

  address:shape({
    id: number.isRequired,
    street: string.isRequired,
    street2: string,
    city: string.isRequired,
    state: string.isRequired,
    postal: number.isRequired
  })
});



// WEBPACK FOOTER //
// ./src/client/types/types.js